// extracted by mini-css-extract-plugin
export var addToCartButton = "_nf-b";
export var arrowButtonContainer = "_nf-9";
export var arrowButtonIcon = "_nf-a";
export var carouselArrowButton = "_nf-6";
export var carouselElementContainer = "_nf-1";
export var left = "_nf-7";
export var productDisplayCarouselContainer = "_nf-0";
export var productTileContainer = "_nf-2";
export var productTileImage = "_nf-4";
export var productTileImageContainer = "_nf-3";
export var productTileTitle = "_nf-5";
export var right = "_nf-8";
export var sliderOverflow = "_nf-c";